import { render, staticRenderFns } from "./groupFileAccessDialog.vue?vue&type=template&id=3c2eb9ff&"
import script from "./groupFileAccessDialog.vue?vue&type=script&lang=js&"
export * from "./groupFileAccessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports